import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { WebSocketSubject } from 'rxjs/observable/dom/WebSocketSubject';
import { webSocket } from 'rxjs/observable/dom/webSocket';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CrsBridgeService {
	private _ws: WebSocketSubject<any> | null = null;
	private _httpsPort = 15001;
	private _socketConnected: Subject<boolean> = new Subject<boolean>();

	public socket$: Observable<any> = new Observable();
	public socketConnected$ = this._socketConnected.asObservable();

	public constructor(private _http: HttpClient) {
	}

	public connect(destinationPort: number) {
		this._httpsPort = destinationPort;

		this._ws = webSocket({
			url: `wss://localhost.schmetterling-argus.de:${this._httpsPort}/ws`,
			resultSelector: (e: MessageEvent) => {
				try {
					return JSON.parse(e.data);
				} catch (err) {
					return {request: 'unknown', payload: e && e.data || null};
				}
			},
		});

		this.socket$ = this._ws.asObservable();
		this._socketConnected.next(true);
	}

	public sendToCrs(targetCrs: string, xml: string): Observable<string> {
		const body = `target=${CrsBridgeService._getCrsForApplicationBridge(targetCrs)}&data=${encodeURIComponent(xml)}`;

		return this._http.post(`https://localhost.schmetterling-argus.de:${this._httpsPort}/handle`, body, {
			responseType: 'text',
			headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})
		});
	}

	private static _getCrsForApplicationBridge(crs: string): string {
		let returnValue = crs;

		switch (crs.toUpperCase()) {
			case 'MERLIN':
				returnValue = 'shopholidays';
				break;

			case 'IRIS':
				returnValue = 'IrisPlus';
				break;

			case 'AMADEUS':
				returnValue = 'Amadeus';
				break;
		}

		return returnValue.toLowerCase();
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/crs-bridge/crs-bridge.service.ts